module.exports = __webpack_public_path__ + "img/202104-light.5bca9010.png";